<template>
    <div>
        <default-navigation></default-navigation>
        <section>
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-7">
                        <h1 class="mb-5">Copyright</h1>
                        <p>
                            Niets van deze website mag zonder voorafgaande schriftelijke toestemming van de auteurs en uitgever gebruikt worden voor overname in andere gedrukte, geprinte, digitale of welke andere vorm dan ook zonder voorafgaande schriftelijke toestemming. De inhoud van deze website is met de grootste zorgvuldigheid samengesteld. Noch de auteurs, noch de uitgever stellen zich echter aansprakelijk voor eventuele schade als gevolg van eventuele onjuistheden en/of onvolkomenheden.
                        </p>
                        <p class="mb-5">
                            Copyright: LOCOmotion<br>
                            Auteurs: Knibbe JJ & Knibbe NE,  LOCOmotion<br>
                            Bouw en design: BenedenBoven<br>
                            Voor vragen kunt u contact opnemen met: <a href="mailto:nico@knibbe.info">nico@knibbe.info</a>
                        </p>
                        <router-link to="/" class="btn btn-primary mb-3">Ga naar de homepage</router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Copyright'
}
</script>
